<div class="main-content">
  <app-header [title]="(isEdit ? 'BANNER_FORM.EDIT_TITLE' : 'BANNER_FORM.CREATE_TITLE') | translate" />
  <div class="row pt-5 mt-4 mt-md-0">
    <div class="col-12">
      @if (!showSuccess && !showError) {
        <app-icam-container [centralIcon]="true" [iconName]="'banner'" [iconColor]="'#e30714'" [iconHeight]="'32px'">
          @if (!isLoading) {
            <div class="banner-container">
              <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-container banner-form d-flex flex-column">
                <div class="form-section banner-config-section w-100">
                  <div class="d-flex align-items-center form-title mt-2" [ngClass]="isLight ? 'light' : 'dark'">
                    <div class="d-flex align-items-center p-2">
                      <img class="section-image" src="../../assets/icon/banner.svg" alt="banner" />
                    </div>
                    <div class="form-title-text-container">
                      <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
                        {{ 'BANNER_FORM.BANNER_CONFIGURATION' | translate }}
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="description">{{ 'BANNER_FORM.DESCRIPTION' | translate }}*</label>
                        <app-icam-input
                          label="{{ 'BANNER_FORM.DESCRIPTION' | translate }}"
                          inputId="description"
                          [isSlim]="true"
                          inputType="text"
                          formControlName="description"
                          [ngClass]="isLight ? 'light' : 'dark'"
                          [required]="true"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="dateRange">{{ 'BANNER_FORM.DATE_RANGE' | translate }}*</label>
                        <app-icam-datepicker
                          #dateRangePicker
                          name="custom_period"
                          (dateChange)="onDateRangeChanged($event)"
                          [isLight]="isLight"
                          [initialValue]="dateRangeValue"
                        ></app-icam-datepicker>
                        @if (
                          (form.get('startDate')?.invalid || form.get('endDate')?.invalid) &&
                          (form.get('startDate')?.touched || form.get('endDate')?.touched)
                        ) {
                          <div class="invalid-feedback d-block">
                            {{ 'BANNER_FORM.REQUIRED_DATE_RANGE' | translate }}
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="geoLocation">{{ 'BANNER_FORM.GEO_LOCATION' | translate }}</label>
                        <app-multi-select-autocomplete
                          formControlName="geoLocation"
                          [placeholder]="'BANNER_FORM.GEO_LOCATION_PLACEHOLDER' | translate"
                          [options]="nationOptions"
                          [displayField]="'name'"
                          [filterFields]="['name']"
                          [required]="false"
                          [fetchFn]="fetchNations"
                        ></app-multi-select-autocomplete>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="machineTypology">{{ 'BANNER_FORM.MACHINE_TYPOLOGY' | translate }}</label>
                        <app-multi-select-autocomplete
                          formControlName="machineTypology"
                          [placeholder]="'BANNER_FORM.MACHINE_TYPOLOGY_PLACEHOLDER' | translate"
                          [options]="typologyOptions"
                          [displayField]="'name'"
                          [filterFields]="['name']"
                          [required]="false"
                          [fetchFn]="fetchTypologies"
                        ></app-multi-select-autocomplete>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="articleTypology">
                          {{ 'BANNER_FORM.ARTICLE_TYPOLOGY' | translate }}
                          @if (form.get('articleTypology')?.disabled) {
                            <small class="text-muted">
                              ({{ 'BANNER_FORM.SELECT_MACHINE_TYPOLOGY_FIRST' | translate }})
                            </small>
                          }
                        </label>
                        <app-icam-autocomplete-select
                          formControlName="articleTypology"
                          [placeholder]="'BANNER_FORM.ARTICLE_TYPOLOGY_PLACEHOLDER' | translate"
                          [options]="articleTypologyOptions"
                          [displayField]="'name'"
                          [valueField]="'id'"
                          [filterFields]="['name']"
                          [required]="false"
                          [fetchFn]="fetchArticleTypologies"
                          id="articleTypology"
                        ></app-icam-autocomplete-select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="operatingSectorList">{{ 'BANNER_FORM.OPERATING_SECTOR' | translate }}</label>
                        <app-multi-select-autocomplete
                          formControlName="operatingSectorList"
                          [placeholder]="'BANNER_FORM.OPERATING_SECTOR_PLACEHOLDER' | translate"
                          [options]="operatingSectorOptions"
                          [displayField]="'name'"
                          [filterFields]="['name']"
                          [required]="false"
                          [fetchFn]="fetchOperatingSectors"
                        ></app-multi-select-autocomplete>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="roles">{{ 'BANNER_FORM.TARGET_ROLES' | translate }}</label>
                        <app-icam-select
                          #roleSelector
                          className="roles-input"
                          [field]="rolesField"
                          (selectedFilter)="onRoleSelected($event)"
                          [translateOptions]="true"
                        ></app-icam-select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="url">{{ 'BANNER_FORM.URL' | translate }}*</label>
                        <app-icam-input
                          label="{{ 'BANNER_FORM.URL_PLACEHOLDER' | translate }}"
                          inputId="url"
                          [isSlim]="true"
                          inputType="text"
                          formControlName="url"
                          [ngClass]="isLight ? 'light' : 'dark'"
                          [required]="true"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="desktopAttachment">{{ 'BANNER_FORM.DESKTOP_ATTACHMENT' | translate }}*</label>
                        <div class="d-flex align-items-center gap-2">
                          <label
                            for="desktopAttachment"
                            class="custom-file-upload"
                            [ngClass]="isLight ? 'light' : 'dark'"
                          >
                            <app-icam-icon iconName="attachment" />
                            {{ 'BANNER_FORM.CHOOSE_DESKTOP_FILE' | translate }}
                          </label>
                        </div>
                        <input
                          id="desktopAttachment"
                          type="file"
                          style="display: none"
                          (change)="onDesktopFileSelected($event)"
                          accept="image/*"
                        />
                        @if (desktopAttachment) {
                          <p class="text-muted">
                            {{ desktopAttachment.name }}
                            <small
                              class="text-decoration-underline"
                              role="button"
                              (click)="removeDesktopAttachment()"
                              (keydown.enter)="removeDesktopAttachment()"
                              tabindex="0"
                            >
                              ({{ 'COMMON.REMOVE' | translate }})
                            </small>
                          </p>
                        }
                        @if (!desktopAttachment && existingDesktopAttachment) {
                          <p class="text-muted">
                            {{ existingDesktopAttachment.fileName }}
                            <small
                              class="text-decoration-underline"
                              role="button"
                              (click)="removeDesktopAttachment()"
                              (keydown.enter)="removeDesktopAttachment()"
                              tabindex="0"
                            >
                              ({{ 'COMMON.REMOVE' | translate }})
                            </small>
                          </p>
                        }
                        @if (
                          form.get('desktopAttachment')?.touched && !desktopAttachment && !existingDesktopAttachment
                        ) {
                          <div class="invalid-feedback d-block">
                            {{ 'BANNER_FORM.REQUIRED_FIELD' | translate }}
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="mobileAttachment">{{ 'BANNER_FORM.MOBILE_ATTACHMENT' | translate }}*</label>
                        <div class="d-flex align-items-center gap-2">
                          <label
                            for="mobileAttachment"
                            class="custom-file-upload"
                            [ngClass]="isLight ? 'light' : 'dark'"
                          >
                            <app-icam-icon iconName="attachment" />
                            {{ 'BANNER_FORM.CHOOSE_MOBILE_FILE' | translate }}
                          </label>
                        </div>
                        <input
                          id="mobileAttachment"
                          type="file"
                          style="display: none"
                          (change)="onMobileFileSelected($event)"
                          accept="image/*"
                        />
                        @if (mobileAttachment) {
                          <p class="text-muted">
                            {{ mobileAttachment.name }}
                            <small
                              class="text-decoration-underline"
                              role="button"
                              (click)="removeMobileAttachment()"
                              (keydown.enter)="removeMobileAttachment()"
                              tabindex="0"
                            >
                              ({{ 'COMMON.REMOVE' | translate }})
                            </small>
                          </p>
                        }
                        @if (!mobileAttachment && existingMobileAttachment) {
                          <p class="text-muted">
                            {{ existingMobileAttachment.fileName }}
                            <small
                              class="text-decoration-underline"
                              role="button"
                              (click)="removeMobileAttachment()"
                              (keydown.enter)="removeMobileAttachment()"
                              tabindex="0"
                            >
                              ({{ 'COMMON.REMOVE' | translate }})
                            </small>
                          </p>
                        }
                        @if (form.get('mobileAttachment')?.touched && !mobileAttachment && !existingMobileAttachment) {
                          <div class="invalid-feedback d-block">
                            {{ 'BANNER_FORM.REQUIRED_FIELD' | translate }}
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  @if (isCurrentUserAdmin) {
                    <button
                      type="submit"
                      class="button-form-submit"
                      [class.disabled]="!form.valid || !isAttachmentsValid() || isLoading"
                      [disabled]="!form.valid || !isAttachmentsValid() || isLoading"
                    >
                      @if (isLoading) {
                        <div class="d-flex justify-content-center">
                          <div class="spinner-border spinner-border-sm" role="status"></div>
                        </div>
                      } @else {
                        {{ isEdit ? ('BANNER_FORM.UPDATE' | translate) : ('BANNER_FORM.SAVE' | translate) }}
                      }
                    </button>
                  }
                </div>
              </form>
            </div>
          }
          @if (isLoading) {
            <div class="loading-container text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
              </div>
              <p class="mt-3">{{ 'COMMON.LOADING' | translate }}</p>
            </div>
          }
        </app-icam-container>
      }

      @if (saveSuccess) {
        <app-icam-container [centralIcon]="true" [iconName]="'OK'" [iconColor]="'#00A5A9'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="success-title mt-4">
              {{ (isEdit ? 'BANNER_FORM.UPDATED_BANNER' : 'BANNER_FORM.CREATED_BANNER') | translate }}
            </h1>
            <button class="btn btn-primary mt-3" (click)="goToList()">
              {{ 'COMMON.RETURN_TO_LIST' | translate }}
            </button>
          </div>
        </app-icam-container>
      }

      @if (deleteSuccess) {
        <app-icam-container [centralIcon]="true" [iconName]="'OK'" [iconColor]="'#00A5A9'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="success-title mt-4">
              {{ 'BANNER_FORM.DELETED_BANNER' | translate }}
            </h1>
            <button class="btn btn-primary mt-3" (click)="goToList()">
              {{ 'COMMON.RETURN_TO_LIST' | translate }}
            </button>
          </div>
        </app-icam-container>
      }

      @if (saveError) {
        <app-icam-container [centralIcon]="true" [iconName]="'KO'" [iconColor]="'#e30714'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="error-title mt-4">
              {{ (isEdit ? 'BANNER_FORM.UPDATE_ERROR' : 'BANNER_FORM.CREATE_ERROR') | translate }}
            </h1>
            <p class="subtitle my-3">
              {{
                (isEdit ? 'BANNER_FORM.UPDATE_ERROR_DESCRIPTION' : 'BANNER_FORM.CREATE_ERROR_DESCRIPTION') | translate
              }}
            </p>
            @if (errorMessage) {
              <div class="text-danger validation-errors">
                @for (line of errorMessage.split('\n'); track line) {
                  <p>{{ line }}</p>
                }
              </div>
            }
            <button class="btn btn-primary" (click)="tryAgain()">
              {{ 'COMMON.TRY_AGAIN' | translate }}
            </button>
            <button class="btn btn-outline-secondary mt-3" (click)="goToList()">
              {{ 'COMMON.RETURN_TO_LIST' | translate }}
            </button>
          </div>
        </app-icam-container>
      }

      @if (deleteError) {
        <app-icam-container [centralIcon]="true" [iconName]="'KO'" [iconColor]="'#e30714'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="error-title mt-4">
              {{ 'BANNER_FORM.DELETE_ERROR_TITLE' | translate }}
            </h1>
            <p class="subtitle my-3">
              {{ 'BANNER_FORM.DELETE_ERROR_DESCRIPTION' | translate }}
            </p>
            @if (errorMessage) {
              <div class="text-danger validation-errors">
                @for (line of errorMessage.split('\n'); track line) {
                  <p>{{ line }}</p>
                }
              </div>
            }
            <div class="d-flex mt-3 gap-3">
              <button class="btn btn-primary" (click)="tryAgain()">
                {{ 'COMMON.TRY_AGAIN' | translate }}
              </button>
              <button class="btn btn-outline-secondary mt-3" (click)="goToList()">
                {{ 'COMMON.RETURN_TO_LIST' | translate }}
              </button>
            </div>
          </div>
        </app-icam-container>
      }

      <div class="form-footer d-flex justify-content-between mt-4">
        @if (!showSuccess && !showError) {
          <div>
            <app-back-button
              class="app-back-button"
              [linkText]="'BANNER_FORM.BACK_TO_BANNERS'"
              (click)="goBack()"
            ></app-back-button>
          </div>
        }
        @if (isCurrentUserAdmin && isEdit && !showSuccess && !showError) {
          <button
            type="button"
            [ngClass]="isLight ? 'btn btn-outline-danger' : 'btn btn-outline-light'"
            (click)="deleteBanner()"
            [class.disabled]="isLoading"
            [disabled]="isLoading"
          >
            @if (isLoading) {
              <div class="d-flex justify-content-center">
                <div class="spinner-border spinner-border-sm" role="status"></div>
              </div>
            } @else {
              {{ 'BANNER_FORM.DELETE_BANNER_BUTTON' | translate }}
            }
          </button>
        }
      </div>
    </div>
  </div>
</div>
<app-footer-copyright />
